import React, {useEffect, useState } from "react";
import Button from "../../components/common/Button";
import Input from "../../components/common/Input";
import Radio from "../../components/common/Radio";
import Jumpbotron from "../../components/common/Jumpbotron";
import Select from "../../components/common/Select";
import Modal from "../../components/common/Modal";
import DatosProveedor from "../../components/common/DatosProveedor";
import Tab from "../../components/common/Tab";
import { useDispatch } from "react-redux";
import { initDataProveedorFormaPago_Ex,initDataProveedorFormaPagoArray_Ex,
        initDataProveedorFormaPago_Val,initDataProveedorFormaPagoArray_Val} from "../../utils/options";
import CustomTable from "../../components/CustomTable";
import TableRimac from "../../components/common/Table/TableRimac";
import { hideLoading, showLoading } from "../../redux/actions/general";
import { headDataUsers } from "../../components/CustomTable/headData";
import usersData from "../../components/CustomTable/usersData";
import addUserIcon from "../../assets/icon_add_user.svg";
import deleteLogo from "../../assets/gl_delete-20.svg";
import "./styles.scss";
import { Checkbox } from "aws-amplify-react";
import { callService } from "../../amplify/callService";
import { CONSTANTES } from "../../utils/Constantes";
import Alert from "../../components/common/Alert";
import { getColorByStatusFlag } from "../../utils/utils";
import { iconEdit, iconCheck } from "../../components/common/icons";
import Chip from "../../components/common/Chip";
import Pagination from "../../components/common/Pagination";
import InputWithDropdown from "../../components/common/InputWithDropdown";
import Validate from "../../utils/Validate";

const ProveedoresFormaPago = ({dataT, keyIndex, handleActualizarFicha, handleChangePaso}) => {
  const dispatch = useDispatch();

  const [openAdd, setOpenAdd] = useState(false);
  const [tagBody, setTagBody] = useState("nostate");  
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });
  const [currentPage, setCurrentPage] = useState();
  const [paginationData, setPaginationData] = useState({
    totalPages: 5,
  });
  const [arrPerfiles, setArrPerfiles] = useState([]);
  const [arrBanco, setArrBanco] = useState([]);
  const [arrMoneda, setArrMoneda] = useState([]);
  const [arrTipoCuenta, setArrTipoCuenta] = useState([]);
  const [data, setData] = useState(Validate.extraerAtributos(initDataProveedorFormaPago_Ex, dataT, initDataProveedorFormaPagoArray_Ex));
  const [validacion, setValidacion] = useState({formaPago:[],formaPagoBienServicio:[]});
  const [msjCuenta, setMsjCuenta] = useState(["",""]);
  useEffect(() => {    
    setData(Validate.extraerAtributos(initDataProveedorFormaPago_Ex, dataT, initDataProveedorFormaPagoArray_Ex));
  }, [dataT]);

  useEffect(() => {
    getBancos();
    getMonedas();
    getTipoCuentas();
  }, []);
  const getBancos = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','BANCO'));
      if (response.ok && response.data && response.data.payload) {
        let bancos = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrBanco(bancos);
      }
    } catch (ex) {
      console.log("Error al obtener getBancos", ex);
    }
  };
  const getMonedas = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','MONEDA'));
      if (response.ok && response.data && response.data.payload) {
        let monedas = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrMoneda(monedas);
      }
    } catch (ex) {
      console.log("Error al obtener getMonedas", ex);
    }
  };
  const getTipoCuentas = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','TIPO_CUENTA'));
      if (response.ok && response.data && response.data.payload) {
        let tipoCuentas = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrTipoCuenta(tipoCuentas);
      }
    } catch (ex) {
      console.log("Error al obtener tipoCuentas", ex);
    }
  };
  const handleChange = (name, value, i) => {
    let jsonAd = {};    
    value = value.toUpperCase ? value.toUpperCase() : value;
    setData({ ...data, [name]: value });
    if(value instanceof Array){
      validacion[name][i]=false;
      setValidacion({ ...validacion, [name]: validacion[name]});
      if(name=='numCuenta'){
        msjCuenta[i]='';
        setMsjCuenta(msjCuenta);
      }
      if (name = 'formaPagoBienServicio') {
        console.log(value);
        setData({ ...data, ['idpMonedaBienServicio']: value[0].idpMoneda });
      }
    }else{
      setValidacion({ ...validacion, [name]: false });
    }
    
  };
  const validarFormulario = () => {
    let resp = true;
    
    for (var name in Object.assign({},initDataProveedorFormaPago_Val,Validate.limpiarObjeto(data))) {
      //if (data.hasOwnProperty(name)){
        if(!data[name] ){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
          //break;
        }
        if(data[name] instanceof Array){
          let limpArr = Validate.limpiarArregloIdProveedor(data[name]);
          data[name] = limpArr.arr;
          if(!data[name][0]){
            if(data[name][1]){
              ((data[name])[0])={};
              ((validacion[name])[0])={};
            }
          }
          if(limpArr.delete.length>0)
            data[name+'Delete'] = limpArr.delete;
          let i=0;
          for(let elem of data[name]){
            if(dataT.idpClasificacion=='EEX'){
              delete elem.idpMoneda;
              delete elem.idpTipoCuenta;
              delete elem.numCuenta;
              delete initDataProveedorFormaPagoArray_Val.idpMoneda;
              delete initDataProveedorFormaPagoArray_Val.idpTipoCuenta;
              delete initDataProveedorFormaPagoArray_Val.numCuenta;
              
            }else{
              elem.idpMoneda = !elem.idpMoneda?"":elem.idpMoneda;
              elem.idpTipoCuenta = !elem.idpTipoCuenta?"":elem.idpTipoCuenta;
              elem.numCuenta = !elem.numCuenta?"":elem.numCuenta;
              initDataProveedorFormaPagoArray_Val.idpMoneda = !initDataProveedorFormaPagoArray_Val.idpMoneda?"":initDataProveedorFormaPagoArray_Val.idpMoneda;
              initDataProveedorFormaPagoArray_Val.idpTipoCuenta = !initDataProveedorFormaPagoArray_Val.idpTipoCuenta?"":initDataProveedorFormaPagoArray_Val.idpTipoCuenta;
              initDataProveedorFormaPagoArray_Val.numCuenta = !initDataProveedorFormaPagoArray_Val.numCuenta?"":initDataProveedorFormaPagoArray_Val.numCuenta;
            }
            for (var name2 in Object.assign({},initDataProveedorFormaPagoArray_Val,Validate.limpiarObjeto(elem))) {
              //if (elem.hasOwnProperty(name2)){                
                if(!elem[name2]){
                  (validacion[name])[i] = (validacion[name])[i]?(validacion[name])[i]:{};
                  ((validacion[name])[i])[name2] = true;
                  setValidacion({...validacion, [name]: validacion[name]});
                  resp = false;
                }
                let msjValCuenta = Validate.validarNumeroCuenta(elem["idpBanco"],elem["idpTipoCuenta"],elem[name2]);
                if(name2=='numCuenta' && msjValCuenta){
                  (validacion[name])[i] = (validacion[name])[i]?(validacion[name])[i]:{};
                  ((validacion[name])[i])[name2] = true;
                  msjCuenta[i] = msjValCuenta;
                  setMsjCuenta(msjCuenta);
                  setValidacion({...validacion, [name]: validacion[name]});
                  resp = false;
                } 
              //}             
            }
            i++;
          }
          if(name=="formaPago" && data[name].length==0){
            validacion[name]=[{idpBanco: true,
                              idpMoneda: true,
                              numCuenta: true,
                              idpTipoCuenta: true}];
            setValidacion({...validacion, [name]: validacion[name]});
            resp = false;
          }
        } 
        /*if(name=='numDocumento' && !Validate.validarDocumento(data.idpTipoDocumento,data[name])){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
        }*/ 
      //}     
    }
    return resp;
  }
  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };
  
  const resetForm =() => {
    
  };

  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);
 

  const handleCloseModal = (value) => {
    setOpenAdd(value);
  };

  const handleChangeEnvioCorreo = (event) => {
    console.log('============', event)
  };

  const handleChangeEmail = (text) => {
    console.log('============', text);
    };


  const handleOpenAddModal = (tag) => {    
    setTagBody(tag);
    resetForm();
    setOpenAdd(true);
  };

  const handleShowModal = (row, tag) => {
    resetForm();
    if (!openAdd) setOpenAdd(true);
    setTagBody(tag);
    if (tag === "edit") fillEditForm(row);
  };

  const fillEditForm = (row)=> {
    console.log(row);
      
  };
  
  const handleCloseAddModal = () => {
    setOpenAdd(false);
  };

  const bodyModalAdd = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">
            Registro para{" "}
            <span className="title-05 color-red">
              <strong>{ tagBody=="add" && ("agregar nueva") } { tagBody=="edit" && ("actualizar") } área</strong>
            </span>
          </h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          
        <div className="d-justify-space-between d-flex-column-m w100">
            <div className="areasLay__formulario--left2Columns">
              <Input label="Nombre de área" />
            </div>
            <div className="usersLay__formulario--right2Columns">
              <Select label="Estado"  />
            </div>
            
        </div>
        <div className="d-justify-space-between d-flex-column-m w100">
            <div className="areassLay__formulario--left2Columns">
            <Checkbox id="chkEnvioCorreo" label="Envío de Correo" />
            <label htmlFor="chkEnvioCorreo">Enviar correo de notificación</label>
            </div>
          
        </div>
        <br/>
        <div className="d-justify-space-between d-flex-column-m w100">
            <div className="areassLay__formulario--left2Columns">
            <Checkbox id="chkEnvioCorreoRecepcion" label="Envío de Correo Recepcion" />
            <label htmlFor="chkEnvioCorreoRecepcion">Correo de recepción de factura</label>
            </div>
            
            
        </div>
      
        </div>
      </div>
    );
  };  
    
  const handleClickRegisterModal = async () => {
      //const { dateTimeCreation, docNumber, clientDoc, id } = selectedRow;
    if(tagBody=="add")
    { 
        const body = {
          payload: {
            
          },
        };
        try {
          dispatch(showLoading());
          const response = await callService(
            "POST",
            CONSTANTES.APIS_PATH.insertArea,
            body
          );
          dispatch(hideLoading());
          // type == 0 => ok , type == 1 => error
          let error = response.data? response.data.type:null;
          if (response.ok && response.data && response.ok == true && error!='1') {
            resetForm();
            setShowAlert({
              show: true,
              title: "Correcto",
              message: response.data.data || "Se guardó el registró",
              type: "success",
            });
            resetMessage(5);
            handleCloseModal(false);            
            setCurrentPage(new Number(1));            
          } else {
            const mesaje = response.message || "Error al registrar";
            setShowAlert({
              show: true,
              title: "Error",
              message: mesaje,
              type: "error",
            });
            resetMessage(5);
          }
          // handleSearchEndpoint();
        } catch (ex) {
          console.log(ex)
          dispatch(hideLoading());
        }
      
    }
    
  };

  const handleSearchEndpoint = async () => {
    let payload = {
     
      
      
    };
    const fetchObj = {
      payload: payload,
    };
    dispatch(showLoading());
    const response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.searchArea,
      fetchObj
    );
    dispatch(hideLoading());
    if (response.ok && response.data) {
      let { totalPages } = response.data;
      setPaginationData({ ...paginationData, totalPages: totalPages });

      let arrData =
        response &&
        response.data &&
        response.data.rows &&
        response.data.rows.map((item) => {
          let obj = {
            id: item.ID,
            dateTimeCreation: item.dateTimeCreation,
            name: item.name,
            email: item.email,
            emailRecepcion: item.emailRecepcion,
            estado: item.estado,
            sendMailValidation:  item.sendMailValidation? item.sendMailValidation: false,
            valEmailRecepcion:  item.valEmailRecepcion? item.valEmailRecepcion: false  
          };
          return obj;
        });
    } else {
      console.log("Error fetching data => ", response.message);
      
    }
  };

  return (
    <div className="step__content" data-key={keyIndex}>
        <div className="proveedores_content">
            <h4 className="title-05 margin-bottom-16 margin-top-16">
                <b>Cuentanos <span class="title-red">mas sobre ti:</span></b>
            </h4>                  
            <div className="d-justify-space-between d-flex-column-m w100">                                  
              <div className="documents_criteria_datos">
                      <p>¿Qué ofrece la empresa a RIMAC?</p>
                      <Radio
                          id="idpBienServicioB"
                          name="idpBienServicio"
                          value="B"
                          onChange={(newValue) => handleChange("idpBienServicio", newValue)}
                          isChecked={data?.idpBienServicio}
                          hasError= {validacion.idpBienServicio && '*'}
                      >
                          Producto/Bien
                      </Radio>
                      <Radio
                          id="idpBienServicioS"
                          name="ofreceEmp"
                          value="S"
                          onChange={(newValue) => handleChange("idpBienServicio", newValue)} 
                          isChecked={data?.idpBienServicio}
                          hasError= {validacion.idpBienServicio && '*'}                           
                      >
                          Servicio
                      </Radio>                      
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Input
                    label="Descripcion del Bien o Servicio"
                    name="descBienServicio"
                    maxLength="500"
                    value={data?.descBienServicio}
                    onChange={(newValue) => handleChange("descBienServicio", newValue)}
                    hasError= {validacion.descBienServicio && '*'}
                    customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                  />
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">                                  
              <div className="documents_criteria_datos">
                      <p>¿Cuál es la frecuencia del Bien o Servicio a RIMAC?</p>
                      <Radio
                          id="P"
                          name="idpFrecuencia"
                          value="UNI"
                          onChange={(newValue) => handleChange("idpFrecuencia", newValue)}
                          isChecked={data?.idpFrecuencia}
                          hasError= {validacion.idpFrecuencia && '*'}
                      >
                          Única
                      </Radio>
                      <Radio
                          id="S"
                          name="idpFrecuencia"
                          value="FRE"
                          onChange={(newValue) => handleChange("idpFrecuencia", newValue)} 
                          isChecked={data?.idpFrecuencia}
                          hasError= {validacion.idpFrecuencia && '*'}                          
                      >
                          Frecuente
                      </Radio>
                      <Radio
                          id="S"
                          name="idpFrecuencia"
                          value="ESP"
                          onChange={(newValue) => handleChange("idpFrecuencia", newValue)} 
                          isChecked={data?.idpFrecuencia}
                          hasError= {validacion.idpFrecuencia && '*'} 
                      >
                          Esporádica
                      </Radio>
              </div>
            </div>                  
            <div className="d-justify-space-between d-flex-column-m w100">                                  
              <div className="documents_criteria_datos">
                      <p>¿El importe del Bien o Servicio a RIMAC es?</p>
                      <Radio
                          id="idpTipoImporteM"
                          name="idpTipoImporte"
                          value="M"
                          onChange={(newValue) => handleChange("idpTipoImporte", newValue)}
                          isChecked={data?.idpTipoImporte}
                          hasError= {validacion.idpTipoImporte && '*'} 
                      >
                          Mensual
                      </Radio>
                      <Radio
                          id="idpTipoImporteA"
                          name="idpTipoImporte"
                          value="A"
                          onChange={(newValue) => handleChange("idpTipoImporte", newValue)} 
                          isChecked={data?.idpTipoImporte}
                          hasError= {validacion.idpTipoImporte && '*'}                           
                      >
                          Anual
                      </Radio>                            
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Input
                    label="Ingresar importe"
                    name="importeBienServicio"
                    maxLength="15"
                    value={data?.importeBienServicio}
                    onChange={(newValue) => handleChange("importeBienServicio", Number(newValue))} 
                    hasError= {validacion.importeBienServicio && '*'}
                    customRegex={/^[0-9]*$/}                     
                  />
              </div>

              <div className="documents_criteria_datostab">
                  <Select
                  label="Moneda Bien Servicio"
                  selected={(data && data.formaPago[0] && arrMoneda.find(obj=>obj.value==data.formaPago[0].idpMoneda))}
                  onChange={(newValue) => {(data.formaPago[0]||(data.formaPago[0]={})).idpMoneda = newValue.value;
                                            handleChange("formaPagoBienServicio", data.formaPago, 0); 
                                            }
                  }
                  items={arrMoneda}
                  hasError= {(validacion.formaPago[0]  && validacion.formaPago[0].idpMoneda) && '*'}
                  />
              </div>

            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Input
                    label="Rubros en los que el proveedor brinda sus productos o servicios"
                    name="rubro"
                    maxLength="1000"
                    value={data?.rubro}
                    onChange={(newValue) => handleChange("rubro", newValue)} 
                    hasError= {validacion.rubro && '*'}
                    customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}                     
                  />
              </div>
            </div>
            <h4 className="title-06 margin-bottom-16 margin-top-48">
                Agregar las formas de Pago:
            </h4> 
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Tab
                  activeTab={0}
                  options={"Cuenta 1|Cuenta 2"}
                  //changeTab={tabQuestions}
                  //disabledTab={tabDisabled}
                  contents={
                  <>
                  <div className="tab__content is-active" data-key={0}>
                    <div className="documents_criteria_datostab">
                        <Select
                        label="Entidad Bancaria"
                        selected={(data && data.formaPago[0] && arrBanco.find(obj=>obj.value==data.formaPago[0].idpBanco))}
                        onChange={(newValue) => {(data.formaPago[0]||(data.formaPago[0]={})).idpBanco = newValue.value;
                                                  handleChange("formaPago", data.formaPago, 0); 
                                                  }
                        }
                        items={arrBanco}
                        hasError= {(validacion.formaPago[0]  && validacion.formaPago[0].idpBanco) && '*'}
                        />
                    </div>
                    {dataT && dataT.idpClasificacion!='EEX' && 
                    <>
                    <div className="documents_criteria_datostab">
                        <Select
                        label="Tipo de Cuenta"
                        selected={(data && data.formaPago[0] && arrTipoCuenta.find(obj=>obj.value==data.formaPago[0].idpTipoCuenta))}
                        onChange={(newValue) => {(data.formaPago[0]||(data.formaPago[0]={})).idpTipoCuenta = newValue.value;
                                                  handleChange("formaPago", data.formaPago, 0); 
                                                  }
                        }
                        items={arrTipoCuenta}
                        hasError= {(validacion.formaPago[0]  && validacion.formaPago[0].idpTipoCuenta) && '*'}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Select
                        label="Moneda"
                        selected={(data && data.formaPago[0] && arrMoneda.find(obj=>obj.value==data.formaPago[0].idpMoneda))}
                        onChange={(newValue) => {(data.formaPago[0]||(data.formaPago[0]={})).idpMoneda = newValue.value;
                                                  handleChange("formaPago", data.formaPago, 0); 
                                                  }
                        }
                        items={arrMoneda}
                        hasError= {(validacion.formaPago[0]  && validacion.formaPago[0].idpMoneda) && '*'}
                        />
                    </div>
                    </>}
                    { dataT && dataT.idpClasificacion=='EEX' &&
                      <div className="documents_criteria_datostab">
                          <Input
                            label="Nombre Entidad Bancaria"
                            name="nombreOtroBanco"
                            maxLength="500"
                            value={(data && data.formaPago[0] && data.formaPago[0].nombreOtroBanco) || ''}
                            onChange={(newValue) => {(data.formaPago[0]||(data.formaPago[0]={})).nombreOtroBanco = String(newValue);
                                                    handleChange("formaPago", data.formaPago, 0); 
                                                    }
                            }
                            customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                            hasError= {(validacion.formaPago[0]  && validacion.formaPago[0].nombreOtroBanco) && '*'}                 
                          />
                      </div> 
                    }
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Número de Cuenta"
                          name="numCuenta"
                          maxLength="100"
                          value={(data && data.formaPago[0] && data.formaPago[0].numCuenta) || ''}
                          onChange={(newValue) => {(data.formaPago[0]||(data.formaPago[0]={})).numCuenta = String(newValue);
                                                  handleChange("formaPago", data.formaPago, 0); 
                                                  }
                          }
                          customRegex={/^[0-9]*$/}
                          hasError= {(validacion.formaPago[0]  && validacion.formaPago[0].numCuenta) && msjCuenta[0]}                 
                        />
                    </div>                          
                  </div>
                  <div className="tab__content" data-key={1}>
                    <div className="documents_criteria_datostab">
                        <Select
                        label="Entidad Bancaria"
                        selected={(data && data.formaPago[1] && arrBanco.find(obj=>obj.value==data.formaPago[1].idpBanco))}
                        onChange={(newValue) => {(data.formaPago[1]||(data.formaPago[1]={})).idpBanco = newValue.value;
                                                  handleChange("formaPago", data.formaPago, 1); 
                                                  }
                        }
                        items={arrBanco}
                        hasError= {(validacion.formaPago[1]  && validacion.formaPago[1].idpBanco) && '*'} 
                        />
                    </div>
                    {dataT && dataT.idpClasificacion!='EEX' && 
                    <>
                    <div className="documents_criteria_datostab">
                        <Select
                        label="Tipo de Cuenta"
                        selected={(data && data.formaPago[1] && arrTipoCuenta.find(obj=>obj.value==data.formaPago[1].idpTipoCuenta))}
                        onChange={(newValue) => {(data.formaPago[1]||(data.formaPago[1]={})).idpTipoCuenta = newValue.value;
                                                  handleChange("formaPago", data.formaPago, 1); 
                                                  }
                        }
                        items={arrTipoCuenta}
                        hasError= {(validacion.formaPago[1]  && validacion.formaPago[1].idpTipoCuenta) && '*'} 
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Select
                        label="Moneda"
                        selected={(data && data.formaPago[1] && arrMoneda.find(obj=>obj.value==data.formaPago[1].idpMoneda))}
                        onChange={(newValue) => {(data.formaPago[1]||(data.formaPago[1]={})).idpMoneda = newValue.value;
                                                  handleChange("formaPago", data.formaPago, 1); 
                                                  }
                        }
                        items={arrMoneda}
                        hasError= {(validacion.formaPago[1]  && validacion.formaPago[1].idpMoneda) && '*'}
                        />
                    </div>
                    </>}
                    { dataT && dataT.idpClasificacion=='EEX' &&
                      <div className="documents_criteria_datostab">
                          <Input
                            label="Nombre Entidad Bancaria"
                            name="nombreOtroBanco"
                            maxLength="500"
                            value={(data && data.formaPago[1] && data.formaPago[1].nombreOtroBanco) || ''}
                            onChange={(newValue) => {(data.formaPago[1]||(data.formaPago[1]={})).nombreOtroBanco = String(newValue);
                                                    handleChange("formaPago", data.formaPago, 1); 
                                                    }
                            }
                            customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                            hasError= {(validacion.formaPago[1]  && validacion.formaPago[1].nombreOtroBanco) && '*'}                 
                          />
                      </div> 
                    }
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Número de Cuenta"
                          name="numCuenta2"
                          maxLength="100"
                          value={(data && data.formaPago[1] && data.formaPago[1].numCuenta)}
                          onChange={(newValue) => {(data.formaPago[1]||(data.formaPago[1]={})).numCuenta = String(newValue);
                                                  handleChange("formaPago", data.formaPago, 1); 
                                                  }
                          }
                          customRegex={/^[0-9]*$/}
                          hasError= {(validacion.formaPago[1]  && validacion.formaPago[1].numCuenta) && msjCuenta[1]}                     
                        />
                    </div> 
                  </div>
                  </>
                  }
                  >
                  </Tab>
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_btns d-flex-end margin-bottom-16">
                <div className="documents_btnSearch">
                  <Button
                    // type="submit"
                    primary
                    size="large"
                    onClick={()=>{
                      if(validarFormulario())
                      {
                        handleActualizarFicha(data);
                        handleChangePaso(keyIndex);
                      }
                      
                    }}
                  >
                    Continuar
                  </Button>
                </div>                  
              </div>
            </div>
        </div>
        <div className="proveedores_margen">
            <DatosProveedor data={dataT}/>       
        </div>
    </div>
  );
};


export default ProveedoresFormaPago;
